import React from 'react';
import styled from 'styled-components';
import { Radio as AntRadio } from 'antd';

const { Group } = AntRadio;

const StyledGroup = styled(Group)`
  display: flex;
  flex-flow: row wrap;
  font-family: var(--font-family-regular);
  gap: ${(props) => props.$gap || '20px'};

  &.vertical {
    flex-direction: column;
    gap: 44px;
    min-width: 200px;

    .ant-radio-wrapper {
      flex: none;
    }
  }
`;

const RadioButton = styled(AntRadio)`
  &.ant-radio-wrapper {
    display: flex;
    flex: ${(props) => (props.$autoHeight ? 'none' : '1 0 calc(50% - 10px)')};
    font-family: var(--font-family-regular);
    font-size: var(--font-size-regular);
    line-height: var(--font-line-height-regular);
    margin: 0;
    max-width: 274px;

    .ant-radio {
      align-self: center;
      background-color: var(--greyscale-porcelain);
      border-color: var(--greyscale-concrete);
      height: 20px;
      top: 1px;
      width: 20px;

      &.ant-radio-checked {
        border-color: var(--primary-oqio-blue);
        border-width: 2px;

        &::after {
          background-color: var(--primary-oqio-blue);
          height: 20px;
          margin-block-start: -10px;
          margin-inline-start: -10px;
          transform: scale(0.5);
          width: 20px;
        }
      }
    }

    &:hover {
      .ant-radio {
        border-color: var(--primary-oqio-blue-hover);
      }
    }

    &.ant-radio-wrapper-disabled {
      color: var(--greyscale-concrete);
      cursor: default;

      .ant-radio {
        background-color: var(--greyscale-dark-white);
        border-color: var(--greyscale-light-grey);
        cursor: default;

        .ant-radio-input {
          cursor: default;
        }
      }
    }
  }
`;

RadioButton.Group = (props) => <StyledGroup {...props} />;

export default RadioButton;
